import { Flow, SipFrequency } from "@ctypes";
import { useGoalFlow } from "@hooks";
import { getRecurringTypeLabel } from "@utils";
import { SharedContributionCard } from "./SharedContributionCard";

export const SharedContribution = () => {
  const {
    goalProps: { flow, pendingInvite },
  } = useGoalFlow();

  if (
    flow !== Flow.AcceptSharedGoal ||
    !pendingInvite?.inviterFirstName ||
    !pendingInvite.recurringDepositInCents
  ) {
    return null;
  }

  const contributionLabel = getRecurringTypeLabel(
    pendingInvite.recurringDepositSchedule ?? SipFrequency.Weekly,
  );

  const partners = pendingInvite.partnerGoalContributions?.map((contributer) => {
    if (!contributer?.partnerFirstName || !contributer.recurringDepositInCents) {
      return null;
    }

    return (
      <SharedContributionCard
        key={contributer.partnerId}
        name={contributer.partnerFirstName}
        recurringDepositInCents={contributer.recurringDepositInCents}
        contributionLabel={contributionLabel}
      />
    );
  });

  return (
    <>
      <SharedContributionCard
        name={pendingInvite.inviterFirstName}
        recurringDepositInCents={pendingInvite.recurringDepositInCents}
        contributionLabel={contributionLabel}
      />
      {partners}
    </>
  );
};
